import 'css-chunksrc/client/scenes/taskCreation/taskCreationForm/participantsList/resource/styles.scss';export default {
  "resource": "_resource_fskbc_1",
  "iconBox": "_iconBox_fskbc_18",
  "icon": "_icon_fskbc_18"
};